import { connect } from 'react-redux';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { CustomLogin } from 'vendor/infrastructure/custom_requests/login';
import { mdiAccount, mdiLock } from '@mdi/js';
import Icon from '@mdi/react';
import { Button, Card, CardActions, CircularProgress } from '@material-ui/core';
import { showNotify } from 'vendor/application/disptach';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
    this.user = '';
    this.passwd = '';

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleSubmit(e) {
    e?.preventDefault?.();

    const { user, passwd } = this;
    if (!user || !passwd) {
      this.props.dispatch(
        showNotify({ message: 'Username and password are required.', severity: 'error' })
      );
      return;
    }

    this.setState({ isLoading: true });

    try {
      const request = new CustomLogin({ username: user, password: passwd }, 'token', this.props);
      const login = await request.make_request_token();
      const userId = this.getUserId(login.access);

      this.props.handleAccess(login, userId);

      this.setState({ isLoading: false });

      this.props.history.push('/');
    } catch (err) {
      const data = { message: err, severity: 'error' };
      this.props.dispatch(showNotify(data));
      this.setState({ isLoading: false });
    }
  }

  getUserId(access) {
    const e = this.b64_to_utf8(access.split('.')[1]);
    return JSON.parse(e).user_id;
  }

  b64_to_utf8(str) {
    return decodeURIComponent(escape(window.atob(str)));
  }

  render() {
    const { isLoading } = this.state;
    return (
      <div className="cen-back">
        <span className="cen-title">DFcentribot</span>
        <Card elevation={3} className="cen-login">
          <div className="cen-border"></div>
          <div className="cen-login-content">
            {/* NAME */}
            <form onSubmit={this.handleSubmit}>
              <div className="display-center">
                <input
                  onChange={(event) => (this.user = event.target.value)}
                  type="text"
                  placeholder="Username"
                />
                <span className="cen-icons user">
                  <Icon path={mdiAccount} size={'25px'} />
                </span>
              </div>
              <div className="display-center">
                <input
                  onChange={(event) => (this.passwd = event.target.value)}
                  type="password"
                  placeholder="Password"
                />
                <span className="cen-icons passwd">
                  <Icon path={mdiLock} size={'25px'} />
                </span>
              </div>
              <CardActions>
                <Button
                  className="cen-btn-submit"
                  type="submit"
                  variant="outlined"
                  onClick={this.handleSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? <CircularProgress size={21} /> : 'Submit'}
                </Button>
              </CardActions>
            </form>
          </div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state,
  };
};

const connect_login = connect(mapStateToProps)(Login);

export default withRouter(connect_login);
